export const getInputIds = deps => {
  let fields = (deps && deps.fields) || {}
  let inputIds = []

  inputIds = Object.values(fields)
    .map(val => val.inputId)
    .filter(val => val)

  return inputIds
}

export const validateNumberInputValue = value => {
  return value.match(/^[+-]?([\d+]*[,\.]?\d*|\.\d+)?$/i)
}
